// phoneUtils.js
// Shared phone display/link helpers for task surfaces.

import React from 'react';

/**
 * Format a phone number for display: "(919) 555-1234".
 * Accepts E.164 (+19195551234), 11-digit (19195551234), or 10-digit input.
 * Returns the input unchanged if it can't be parsed.
 */
export const formatPhoneDisplay = (raw) => {
  if (!raw) return '';
  let digits = String(raw).replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
  if (digits.length !== 10) return raw;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

/** tel: href from any phone representation (keeps leading +). */
export const telHref = (raw) => `tel:${String(raw || '').replace(/[^\d+]/g, '')}`;

// Linkify phone numbers in text (e.g. "555-867-5309" → clickable tel: link)
export const PHONE_REGEX = /(\+?1?[-.\s]?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4})/g;

export function renderWithPhoneLinks(text, linkColor = 'var(--color-info)') {
  if (!text) return null;
  const parts = text.split(PHONE_REGEX);
  return parts.map((part, i) => {
    if (PHONE_REGEX.test(part)) {
      PHONE_REGEX.lastIndex = 0; // reset regex state
      const digits = part.replace(/[^\d+]/g, '');
      return (
        <a key={i} href={`tel:${digits}`} style={{ color: linkColor, fontWeight: 600 }}>
          {part}
        </a>
      );
    }
    return part;
  });
}
